import clsx from 'clsx';
import styles from './Divider.module.scss';

export type DividerProps = {
  className?: string;
  variant?: 'primary' | 'secondary';
};

export const Divider = ({ className, variant = 'primary' }: DividerProps) => {
  const classes = clsx(styles.divider, variant && styles[variant], className);
  return <hr className={classes} />;
};
